"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Column_1 = __importDefault(require("./Column/Column"));
var react_1 = require("react");
var treetable_1 = require("primereact/treetable");
/**
 * TreeTable is used to display hierarchical data in tabular format.
 * @child ./Column/Column.tsx
 */
var TreeTable = /** @class */ (function (_super) {
    __extends(TreeTable, _super);
    function TreeTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genColumns = function () {
            var children = _this.props.children;
            var columns;
            if (children) {
                var expander_1 = true;
                columns = React.Children.map(children, function (child) {
                    var column;
                    if (typeof child === 'object' && child.type === Column_1.default) {
                        column = React.cloneElement(child, { expander: expander_1 });
                        expander_1 = false;
                    }
                    return column;
                }).filter(function (column) { return column !== undefined; });
            }
            else {
                columns = null;
            }
            return columns;
        };
        return _this;
    }
    TreeTable.prototype.render = function () {
        var data = this.props.data;
        return (React.createElement(treetable_1.TreeTable, { value: data }, this.genColumns()));
    };
    TreeTable.Column = Column_1.default;
    return TreeTable;
}(react_1.Component));
exports.default = TreeTable;
//# sourceMappingURL=TreeTable.js.map